<script setup lang="ts">
import { Car, HeartPulse, House, Plane, ShieldCheck } from 'lucide-vue-next'

// Insurance policy with the main kinds of cover
const { t } = useI18n()

const kinds = [
  { key: 'auto', icon: Car },
  { key: 'health', icon: HeartPulse },
  { key: 'property', icon: House },
  { key: 'travel', icon: Plane }
] as const
</script>

<template>
  <div class="relative w-[21rem] select-none" aria-hidden="true">
    <div class="absolute inset-x-6 -top-2 h-full -rotate-3 rounded-2xl bg-blue-100" />

    <div class="HeroIllustrationCard">
      <div class="flex items-center gap-3">
        <span class="grid size-11 place-items-center rounded-xl bg-blue-600 text-white">
          <ShieldCheck class="size-5" />
        </span>
        <div class="flex-1">
          <div class="font-serif text-xl font-bold">{{ t('widget.hero_banner.illustration.insurances.policy') }}</div>
          <div class="text-sm text-gray-500">№ 0428 1957</div>
        </div>
        <span class="rounded-full bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-700">
          {{ t('widget.hero_banner.illustration.insurances.active') }}
        </span>
      </div>

      <div class="mt-4 grid grid-cols-2 gap-1.5">
        <div v-for="kind in kinds" :key="kind.key" class="flex items-center gap-2 rounded-xl bg-blue-50 px-3 py-2.5">
          <component :is="kind.icon" class="size-4 text-blue-600" />
          <span class="text-sm font-semibold">{{ t(`widget.hero_banner.illustration.insurances.${kind.key}`) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
